import { SettingsLayout } from '../components/settings-layout';
import { BillingPage } from './billing-page';
import { ComputersPage } from './computers-page';

export function SettingsBillingCreditsPage() {
  return (
    <SettingsLayout current="billing-credits">
      <BillingPage section="credits" />
    </SettingsLayout>
  );
}

export function SettingsBillingPlansPage() {
  return (
    <SettingsLayout current="billing-plans">
      <BillingPage section="plans" />
    </SettingsLayout>
  );
}

export function SettingsBillingRedeemPage() {
  return (
    <SettingsLayout current="billing-redeem">
      <BillingPage section="redeem" />
    </SettingsLayout>
  );
}

export function SettingsComputersPage() {
  return (
    <SettingsLayout current="computers">
      <ComputersPage />
    </SettingsLayout>
  );
}
